/**
 * quoteSuites.ts — Predefined test bundles for one-click add on the quote editor.
 *
 * FEAT-2026-0016: the lab typically quotes the full rock testing suite together
 * (UCS, UCS with Modulus, TCS single-stage, BTS, rock Direct Shear), so the
 * Pricing tab offers an "Add Rock Testing Suite" button beside "Add Custom Line".
 *
 * Names are canonical `TestCatalogItem.TestName` values (the right-hand-side
 * namespace of rockTestCrosswalk.ts). Resolution to catalog keys happens at
 * click time against the live catalog, so admin price/quantity edits are always
 * honoured; a renamed or deactivated catalog item surfaces as a "not found"
 * warning rather than a stale add.
 */

export interface QuoteTestSuite {
  /** Button / snackbar label. */
  label: string;
  /** Canonical TestCatalogItem.TestName values, in the order they'll be added. */
  testNames: string[];
}

export const ROCK_TESTING_SUITE: QuoteTestSuite = {
  label: 'Rock Testing Suite',
  testNames: [
    'UCS',                             // UCS  (D7012)
    'UCS with Modulus',                // UCSM (D7012)
    'Rock Triaxial (Single Stage)',    // TCS  (D7012)
    'Brazilian Tensile Strength',      // BTS  (D3967)
    'Rock Direct Shear',               // DS   (D5607)
  ],
};
